import React from 'react';
import { Grid } from '@mui/material';
import { GivelifyButton } from '../../button';
import { ActionsRow } from '../style';
import type { ImageEditorCopy } from '../types';

export type ActionButtonsProps = {
    isBusy: boolean;
    isResetVisible: boolean;
    isUploading: boolean;
    onReset: () => void;
    onClose: () => void;
    onApply: () => void;
    copy: ImageEditorCopy;
    editorName: string;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({
    isBusy,
    isResetVisible,
    isUploading,
    onReset,
    onClose,
    onApply,
    copy,
    editorName,
}) => (
    <ActionsRow
        item
        display="flex"
        justifyContent="space-between"
        marginTop={isBusy ? '32px' : 0}
    >
        <Grid item>
            {isResetVisible ? (
                <GivelifyButton
                    className="reset-button"
                    id={`${editorName}-reset-button`}
                    onClick={onReset}
                    size="large"
                    text={copy.resetButton}
                    variant="ghost"
                />
            ) : null}
        </Grid>
        <Grid item display="flex" gap="16px" justifyContent="end" md={8} xs={12}>
            <GivelifyButton
                fullWidth
                className="action-button"
                disabled={isUploading}
                id={`${editorName}-cancel-button`}
                onClick={onClose}
                size="large"
                text={copy.cancelButton}
            />
            <GivelifyButton
                fullWidth
                className="action-button"
                disabled={isBusy}
                id={`${editorName}-save-button`}
                isLoading={isUploading}
                onClick={onApply}
                size="large"
                text={copy.saveButton}
                variant="primary"
            />
        </Grid>
    </ActionsRow>
);
